import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { async } from 'rxjs';
import { AsyncJob } from '../../models/async-job.model';
import { DocumentPublishingSettings } from '../../models/document-publishing-settings.model';
import { AsyncJobService } from '../../services/async-job.service';
import { DocumentPublishingService } from '../../services/document-publishing.service';
import { AsyncJobDialogBase, JOB_COMPLETED_MESSAGE } from '../async-job-base/async-job-base.dialog';

@Component({
    selector: 'app-export',
    templateUrl: './document-publishing-picker.dialog.html',
    styleUrls: [
        '../async-job-base/async-job-base.dialog.scss',
        './document-publishing-picker.dialog.scss'
    ],
    standalone: false
})
export class DocumentPublishingPickerDialog extends AsyncJobDialogBase implements OnInit {

    @ViewChild('executionSummary') executionSummaryDiv: ElementRef<HTMLElement>;

    private settings: DocumentPublishingSettings[];
    private selectedSetting: DocumentPublishingSettings;
    private entityType: string;
    private entityId: number;
    private status: string;
    private publishedDocUrl: string;
    private executionSummaryText: string;
    private entityIds: number[];
    public readonly OUTPUT_TYPE_EMAIL: string = "Email";

    constructor(
        public dialogRef: MatDialogRef<DocumentPublishingPickerDialog>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private documentPublishingService: DocumentPublishingService, injectedAsyncJobService: AsyncJobService) {
        super(injectedAsyncJobService);
        this.settings = data.settings;
        this.entityType = data.entityType;
        this.entityId = data.entityId;
        this.entityIds = data.entityIds;

        if (this.entityIds) {
            this.entityId = this.entityIds[0];
        }
        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'DocumentPublishingPickerDialog';
    }

    ngOnInit(): void {
    }

    public onSelectionChange(es: DocumentPublishingSettings): void {
        this.selectedSetting = es;
        this.executionSummaryText = `Ready to publish ${this.selectedSetting.FileName} ... `;

        this.reInit();
        this.publishedDocUrl = null;
    }

    public jobCompletedArrowFunction = (asyncJob: AsyncJob) => {
        if (asyncJob.status == 'Completed with error') {
            this.executionSummaryText = asyncJob.stdError;
        } else {
            this.publishedDocUrl = this.documentPublishingService.getPublishedDocUrl(asyncJob, this.entityType, this.entityId, this.selectedSetting.id);
            this.executionSummaryText = `${this.executionSummaryText}DONE!`
        }
    };

    public jobUpdatedArrowFunction = (asyncJob: AsyncJob) => {
        if (asyncJob.stdOut) {
            let json = JSON.parse(asyncJob.stdOut);
            this.executionSummaryText = json.JobSummaryMessage;
        }
    };

    public startPublishJob() {
        this.status = "publishing";
        // pharvey - 5/15/2024 - for VNEXT-1289 to allow the publishing of multiple forms 
        if (this.entityIds) {
            if (this.selectedSetting.outputType != this.OUTPUT_TYPE_EMAIL) {
                this.documentPublishingService.publishMultiple(this.entityType, this.entityIds, this.selectedSetting.id).then(asyncJob => {
                    this.executionSummaryText = `Preparing to publish ${this.selectedSetting.FileName}...`;
                    this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobUpdatedArrowFunction);
                });
            }
            else {
                //***Handle Email Publishing Type*/
                this.documentPublishingService.addFormsToEmailQueue(this.entityIds, this.selectedSetting.id).then(asyncJob => {
                    this.executionSummaryText = `Preparing to email ${this.selectedSetting.FileName}...`;
                    this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobUpdatedArrowFunction);
                });
            }
            
        } else {
            this.documentPublishingService.publish(this.entityType, this.entityId, this.selectedSetting.id).then(asyncJob => {
                this.executionSummaryText = `Preparing to publish ${this.selectedSetting.FileName}...`;
                this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobUpdatedArrowFunction);
            });
        }
    }

    public get PublishedDocUrl(): string {
        return this.publishedDocUrl;
    }

    public get Settings(): DocumentPublishingSettings[] {
        return this.settings;
    }

    public get SelectedSetting(): DocumentPublishingSettings {
        return this.selectedSetting;
    }

    public get SelectedDocument(): string {
        return this.selectedSetting == null ? "" : this.selectedSetting.outputType;
    }

    public get Status(): string {
        return this.status;
    }

    public get JobStatus(): string {
        let status: string = null;

        if ((!this.jobInProgress) && (this.asyncJobInfo == null)) {
            status = 'Not started';
        } else if (this.jobInProgress) {
            status = 'Publishing in progress';
        } else if (!this.jobErrorOccurred) {
            if (this.selectedSetting.outputType == this.OUTPUT_TYPE_EMAIL)
                status = "Your document has has been processed. Click \"Done\" below";
            else
                status = "Your document is ready. Click the \"Download\" link below";
        } else {
            status = 'A publishing error occurred';
        }

        return (status);
    }

    public get ReadyToPublish(): boolean {
        return this.SelectedSetting == null || this.JobStatus == 'Publishing in progress';
    }

    public get ExecutionSummaryText(): string {
        // scroll down as messages get added
        if (this.executionSummaryText && this.executionSummaryDiv) {
            this.executionSummaryDiv.nativeElement.scrollTop = this.executionSummaryDiv.nativeElement.scrollHeight;
        }
        return this.executionSummaryText;
    }

}
